// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* White */7,
            _0: /* Light */2
          }),
      tl: {
        hd: BrowserStyle.border(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
              TAG: /* Grey */2,
              _0: /* Light */3
            }),
        tl: {
          hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
          tl: {
            hd: BrowserStyle.boxSizing("borderBox"),
            tl: {
              hd: BrowserStyle.display(BrowserStyle.flexBox),
              tl: {
                hd: BrowserStyle.flexDirection(BrowserStyle.column),
                tl: {
                  hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                  tl: {
                    hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                    tl: {
                      hd: BrowserStyle.overflow(BrowserStyle.hidden),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container
};

var make = React.forwardRef(function (Props, ref_) {
      var className = Props.className;
      var children = Props.children;
      var tmp = {
        className: BrowserStyle.Utils.extendBaseStyle(container, className)
      };
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      return React.createElement("div", tmp, children);
    });

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
